 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard~extra":"dashboard~extra","dashboard":"dashboard","extra":"extra","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-01c32d3a":"9bcb6a59","chunk-074694fa":"fabb448a","chunk-0d7b152c":"ddc6b265","chunk-10cdfd84":"8d3b16e0","chunk-49bc7d99":"1b54e5b8","chunk-1510c6fe":"7df34b40","chunk-1633b25b":"277e8790","chunk-196caa1a":"886c001e","chunk-294b265d":"15e0cbfc","chunk-2becfd1a":"6572af8a","chunk-2d0b919a":"7997c938","chunk-2d0bced2":"5073673a","chunk-2d0c9517":"5a056c2d","chunk-2d0daea6":"ed4d31d9","chunk-37729068":"479ecba4","chunk-3a383e43":"d78697fb","chunk-3bca5ade":"73bd115d","chunk-47475f48":"bd1aa381","chunk-49a06674":"cec7d087","chunk-53566aa3":"a961cd8a","chunk-5789363a":"2677dd6c","chunk-0416da42":"4924f764","chunk-2d21e241":"166ac555","chunk-66bb0f70":"cb8d4949","chunk-74b9266b":"7846d6d3","chunk-7d945cd8":"0d14ae30","chunk-b5a26930":"77430871","chunk-dd7c43ac":"f5045f67","chunk-e7a6e854":"e9d76484","chunk-ea1d6660":"3896e73d","chunk-f2e1cc14":"9cd4d15d","chunk-f6cc47e4":"872de449","chunk-4717a82c":"bc39faf3","chunk-79bb67a8":"ce5754cc","chunk-67f21ba4":"a3a36c80","chunk-18a3027c":"ca72fadc","chunk-931a6dce":"06bd96c4","chunk-6f2680c4":"37ca9965","chunk-750d0c9e":"2ec0b20c","dashboard~extra":"c89ac60c","dashboard":"b32372c3","extra":"4d722398","pages":"a46edac7","chunk-490e6dd7":"94936552"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01c32d3a":1,"chunk-074694fa":1,"chunk-0d7b152c":1,"chunk-10cdfd84":1,"chunk-49bc7d99":1,"chunk-1510c6fe":1,"chunk-1633b25b":1,"chunk-196caa1a":1,"chunk-2becfd1a":1,"chunk-37729068":1,"chunk-3a383e43":1,"chunk-3bca5ade":1,"chunk-49a06674":1,"chunk-53566aa3":1,"chunk-5789363a":1,"chunk-0416da42":1,"chunk-66bb0f70":1,"chunk-74b9266b":1,"chunk-7d945cd8":1,"chunk-b5a26930":1,"chunk-dd7c43ac":1,"chunk-e7a6e854":1,"chunk-ea1d6660":1,"chunk-f2e1cc14":1,"chunk-f6cc47e4":1,"chunk-4717a82c":1,"chunk-79bb67a8":1,"chunk-67f21ba4":1,"chunk-18a3027c":1,"chunk-931a6dce":1,"chunk-6f2680c4":1,"chunk-750d0c9e":1,"dashboard~extra":1,"dashboard":1,"extra":1,"pages":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard~extra":"dashboard~extra","dashboard":"dashboard","extra":"extra","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-01c32d3a":"d02da762","chunk-074694fa":"d02da762","chunk-0d7b152c":"d02da762","chunk-10cdfd84":"ac91e833","chunk-49bc7d99":"0e433876","chunk-1510c6fe":"3e5476a4","chunk-1633b25b":"e9655486","chunk-196caa1a":"c3a853fa","chunk-294b265d":"31d6cfe0","chunk-2becfd1a":"b14a1a4c","chunk-2d0b919a":"31d6cfe0","chunk-2d0bced2":"31d6cfe0","chunk-2d0c9517":"31d6cfe0","chunk-2d0daea6":"31d6cfe0","chunk-37729068":"dbaaf2e7","chunk-3a383e43":"d02da762","chunk-3bca5ade":"dfd7de5e","chunk-47475f48":"31d6cfe0","chunk-49a06674":"73fce22a","chunk-53566aa3":"d02da762","chunk-5789363a":"ae0fffef","chunk-0416da42":"5309c843","chunk-2d21e241":"31d6cfe0","chunk-66bb0f70":"d02da762","chunk-74b9266b":"d02da762","chunk-7d945cd8":"ef2ab3f2","chunk-b5a26930":"d02da762","chunk-dd7c43ac":"7aa485f1","chunk-e7a6e854":"22bfeb7d","chunk-ea1d6660":"a98e34a8","chunk-f2e1cc14":"d02da762","chunk-f6cc47e4":"3a1c6985","chunk-4717a82c":"be967843","chunk-79bb67a8":"53b5742f","chunk-67f21ba4":"59c6fc5b","chunk-18a3027c":"6ecbaf9d","chunk-931a6dce":"5a74a033","chunk-6f2680c4":"19c6b061","chunk-750d0c9e":"d02da762","dashboard~extra":"a80b77e4","dashboard":"25d584ba","extra":"d6194882","pages":"aa1ea5d6","chunk-490e6dd7":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
